import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

const DOT_ROTATIONS = [0, 45, 90, 135, 180, 225, 270, 315] as const;

export type DotSpinnerVariant = 'standalone' | 'withAsset';
export type DotSpinnerSize = 'default' | 'large';
export type DotSpinnerProps = {
    variant?: DotSpinnerVariant;
    size?: DotSpinnerSize;
};

export function DotSpinner({ variant = 'withAsset', size = 'default' }: DotSpinnerProps): JSX.Element {
    const activeDotClassName = variant === 'withAsset' ? 'bg-gray-950' : 'bg-neutral-dark-500';
    const inactiveDotClassName = 'bg-gray-100';

    const wrapperClassName = twMerge(
        'relative animate-spin [animation-duration:2s] [animation-timing-function:steps(8,end)]',
        size === 'default' && 'size-12',
        size === 'large' && 'size-20 2xl:size-36',
    );

    const dotClassName = twMerge(
        'absolute left-1/2 -translate-x-1/2 top-0 rounded-full',
        size === 'default' && 'size-2',
        size === 'large' && 'size-4 2xl:size-7',
    );

    return (
        <div className={wrapperClassName}>
            {DOT_ROTATIONS.map((rotation, index) => (
                <div key={rotation} className="absolute inset-0" style={{ transform: `rotate(${rotation}deg)` }}>
                    <div className={twMerge(dotClassName, index === 0 ? activeDotClassName : inactiveDotClassName)} />
                </div>
            ))}
        </div>
    );
}
